// extracted by mini-css-extract-plugin
export default {"melodyVideo":"GM-z","isFullWidth":"HM-z","landingPageVideo":"IM-z","play":"JM-z","iframeVideo":"KM-z","playHidden":"LM-z","fullwidth":"MM-z"};